import React from 'react';
import styled from '@emotion/styled';
import { injectIntl } from 'react-intl';
import { AnyRoadLogoGrayFooter2023 } from 'views/anyguide/layout/logo/images/AnyRoadLogoGrayFooter2023.tsx';
import { colors } from 'ui_system/compass';

import './index.scss';

const Bullet = styled.span`
  color: ${colors.text.icon};
  font-size: 10px;
  margin: 0 8px;
`;

class PoweredBy extends React.Component {
  _link = (linkDestination, linkText) => {
    const styling = {};
    return (
      <a
        target="_blank"
        className="terms-link"
        style={styling}
        rel="noopener noreferrer"
        href={linkDestination}
      >
        {linkText}
      </a>
    );
  };

  render() {
    const { hidePolicyLinks, intl } = this.props;

    return (
      <p className="PoweredBy">
        <a
          aria-label="Anyroad logo a link to the landing page"
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.anyroad.com/"
        >
          <AnyRoadLogoGrayFooter2023 className="Logo" />
        </a>
        {!hidePolicyLinks && (
          <div className="terms-links-container">
            {this._link(
              'https://www.anyroad.com/end-user-terms',
              intl.formatMessage({
                id: 'TERMS_OF_SERVICE',
                defaultMessage: 'Terms of Service',
              })
            )}
            <Bullet>●</Bullet>
            {this._link(
              'https://www.anyroad.com/privacy',
              intl.formatMessage({
                id: 'PRIVACY_POLICY',
                defaultMessage: 'Privacy Policy',
              })
            )}
          </div>
        )}
      </p>
    );
  }
}

export default injectIntl(PoweredBy);
